import React,{useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Avatar,
  Divider
} from '@mui/material';
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import appImg from '../icon/application.png';
import settingsImg from '../icon/settings.png';
import bsImg from '../icon/bs.png';
import creditImg from '../icon/credit.png';
import scoreImg from '../icon/score.png';
import debatImg from '../icon/debat.png';
import homeImg from '../icon/home.png';
import logo from '../icon/white-logo.png';
import userImg from '../icon/user.png';
import logoutImg from '../icon/logout.png';

const drawerWidth = '16.25rem'; // 260px
const collapsedWidth = '4.375rem'; // 70px

const menuItems = [
  // { text: 'Home', icon: homeImg, id: 'home', route: '/dashboard' },
  // { text: 'Application', icon: appImg, id: 'application', route: '/applicationsummary' },
  { text: 'Intelligence Services', icon: appImg, id: 'dashboardanalyzer', route: '/dashboard-analyzer' },
 
  // { text: 'Individuals', icon: bsImg, id: 'individuals', route: '/individuals' },
  // { text: 'Company', icon: scoreImg, id: 'company', route: '/company' },
  // { text: 'User Management', icon: userImg, id: 'users', route: '/users' },
];

const bottomMenu = [
  // { text: "Settings", icon: settingsImg, id: "settings", route: "/settings" },
  { text: "Logout", icon: logoutImg, id: "logout", route: null },
];

const Sidebar = ({ activeItem, onItemClick, collapsed, onLogout, onToggleSidebar }) => {
  const [active, setActive] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle item clicks with routing
  const handleItemClick = (item) => {
    // If onItemClick prop is provided, call it (for backward compatibility)
    if (onItemClick) {
      onItemClick(item.id);
    }

    // Handle routing
    if (item.id === 'logout') {
      // Handle logout
      if (onLogout) {
        onLogout();
      } else {
        // Default logout behavior
        localStorage.removeItem('authToken');
        navigate('/');
      }
    } else if (item.route) {
      // Navigate to the route
      navigate(item.route);
    }
  };

  // Get active item based on current route (fallback if activeItem prop not provided)
  const getCurrentActiveItem = () => {
    if (activeItem) {
      return activeItem; // Use prop if provided
    }
   
    // Otherwise, determine from current route
    const currentPath = location.pathname;
    const activeMenuItem = menuItems.find(item => item.route === currentPath);
    return activeMenuItem ? activeMenuItem.id : null;
  };

  const currentActiveItem = getCurrentActiveItem();

  return (
    <Drawer
      sx={{
        width: collapsed ? collapsedWidth : drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: collapsed ? collapsedWidth : drawerWidth,
          boxSizing: 'border-box',
          bgcolor: '#034A7F',
          border: 'none',
          fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
          transition: 'width 0.3s ease-in-out',
          overflow: 'hidden'
        },
      }}
      variant="permanent"
      anchor="left"
    >
      {/* Logo Section */}
      <Box sx={{ 
        // p: 2, 
        // display: 'flex', 
        // alignItems: 'center', 
        // fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif', 
        // gap: 1, 
        // justifyContent: collapsed ? 'center' : 'flex-start',
      }}>
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{ 
            marginTop:'1.5rem',
            // width: collapsed ? '2.5rem' : '8rem',
            // height: 'auto',
            // objectFit: 'contain',
            // transition: 'width 0.3s ease-in-out',
          }}
        />
        {/* {!collapsed && (
          <Typography variant="h6" sx={{ 
            fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
            fontWeight: 'bold',
            fontSize: '1.625rem', 
            color: 'white' 
          }}>
            LendingX
          </Typography>
        )} */}
      </Box>

      {/* Navigation Menu */}
      <List sx={{ px: 1, flex: 1 }}>
        {menuItems.map((item) => (
          <ListItem
            key={item.id}
            onClick={() => handleItemClick(item)}
            sx={{
              mb: 0.5,
              cursor: 'pointer',
              fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
              position: 'relative',
              justifyContent: collapsed ? 'center' : 'flex-start',
              paddingRight: '0 !important',
              paddingLeft: 2,
              paddingTop: 1.5,
              paddingBottom: 1.5,
              width: collapsed ? '3.875rem' : '15.75rem',
              
              // Curved active styling
              ...(currentActiveItem === item.id && {
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  right: 0,
                  top: '-1.25rem',
                  width: '1.25rem',
                  height: '1.25rem',
                  bgcolor: 'transparent',
                  borderBottomRightRadius: '3.125rem',
                  boxShadow: '0.3125rem 0.3125rem 0 0.3125rem white',
                  // boxShadow: '3px 10px 0 3px white',

                  p: 0
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  right: 0,
                  bottom: '-1.25rem',
                  width: '1.25rem',
                  height: '1.25rem',
                  bgcolor: 'transparent',
                  borderTopRightRadius: '3.125rem',
                  boxShadow: '0.3125rem -0.3125rem 0 0.3125rem white',
                  // boxShadow: '3px -10px 0 3px white',
                  p: 0
                }
              }),
              // Main item styling
              bgcolor: currentActiveItem === item.id ? 'white' : 'transparent',
              color: currentActiveItem === item.id ? '#034A7F' : 'black',
              borderTopLeftRadius: currentActiveItem === item.id ? '1.5625rem' : '0.5rem',
              borderBottomLeftRadius: currentActiveItem === item.id ? '1.5625rem' : '0.5rem',
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              transition: 'all 0.3s ease-in-out',

              // REMOVED HOVER EFFECTS
              // '&:hover': {
              //   bgcolor: currentActiveItem === item.id ? 'white' : 'rgba(255,255,255,0.1)',
              //   transform: 'translateX(2px)',
              // },
              
              '& .MuiListItemIcon-root': {
                transition: 'all 0.3s ease-in-out',
                color: 'black'
              },
              '& .MuiListItemText-primary': {
                color: currentActiveItem === item.id ? 'black' : 'white',
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 0 : 2 }}>
              <Box
                component="img"
                src={item.icon}
                alt={item.text}
                sx={{
                  fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
                  width: '1.5rem',
                  height: '1.5rem',
                  transition: 'all 0.3s ease-in-out',
                  filter: currentActiveItem === item.id ? 'none' : 'brightness(0) invert(1)',
                }}
              />
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary={item.text}
                sx={{
                  fontSize: '1rem',
                  fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  opacity: collapsed ? 0 : 1,
                  transition: "opacity 0.3s ease",
                  '& .MuiTypography-root': {
                    fontWeight: currentActiveItem === item.id ? 600 : 400,
                    fontSize: '0.9375rem'
                  }
                }}
              />
            )}
          </ListItem>
        ))}
      </List>

      {/* Bottom Menu */}
      <Box sx={{ mt: 'auto', pb: 2 }}>
        <List sx={{ px: 1 }}>
          {bottomMenu.map((item) => (
            <ListItem
              key={item.id}
              onClick={() => handleItemClick(item)}
              sx={{
                mb: 0.5,
                cursor: 'pointer',
                fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
                position: 'relative',
                justifyContent: collapsed ? 'center' : 'flex-start',
                paddingRight: '0 !important',
                paddingLeft: 2,
                paddingTop: 1.5,
                paddingBottom: 1.5,
                // Curved active styling
                ...(currentActiveItem === item.id && {
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    right: 0,
                  top: '-0.9375rem',
                  width: '1.5625rem',
                  height: '1.5625rem',
                    bgcolor: 'transparent',
                  borderBottomRightRadius: '0.9375rem',
                    // boxShadow: '0px 15x 0 0 white'
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    right: 0,
                  bottom: '-0.9375rem',
                  width: '1.5625rem',
                  height: '1.5625rem',
                    bgcolor: 'transparent',
                  borderTopRightRadius: '0.9375rem',
                    // boxShadow: '0px -15px 0 0 white'
                  }
                }),
                // Main item styling
                bgcolor: currentActiveItem === item.id ? 'white' : 'transparent',
                color: currentActiveItem === item.id ? '#1a73e8' : 'white',
              borderTopLeftRadius: currentActiveItem === item.id ? '1.5625rem' : '0.5rem',
              borderBottomLeftRadius: currentActiveItem === item.id ? '1.5625rem' : '0.5rem',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                transition: 'all 0.3s ease-in-out',

                // REMOVED HOVER EFFECTS
                // '&:hover': {
                //   bgcolor: currentActiveItem === item.id ? 'white' : 'rgba(255,255,255,0.1)',
                //   transform: 'translateX(2px)',
                // },
              }}
            >
              <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 0 : 2 }}>
                <Box
                  component="img"
                  src={item.icon}
                  alt={item.text}
                  sx={{
                    fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
                    width: '1.5rem',
                    height: '1.5rem',
                    transition: 'all 0.3s ease-in-out',
                    filter: currentActiveItem === item.id ? 'none' : 'brightness(0) invert(1)',
                  }}
                />
              </ListItemIcon>
              {!collapsed && (
                <ListItemText
                  primary={item.text}
                  sx={{
                    fontSize: '1rem',
                    fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    opacity: collapsed ? 0 : 1,
                    transition: "opacity 0.3s ease",
                    '& .MuiTypography-root': {
                      fontWeight: currentActiveItem === item.id ? 600 : 400,
                      fontSize: '0.9375rem'
                    }
                  }}
                />
              )}
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Toggle Button */}
      <IconButton
        onClick={onToggleSidebar}
        sx={{
          position: "fixed",
          top: "2.9rem",
          left: collapsed ? `calc(${collapsedWidth} - 0.75rem)` : `calc(${drawerWidth} - 0.75rem)`,
          bgcolor: "white",
          border: "0.0625rem solid #ddd",
          boxShadow: "0 0.125rem 0.375rem rgba(0,0,0,0.08)",
          zIndex: 1300,
          transition: "left 0.3s ease",
          width: '1.75rem',
          height: '1.75rem',
          "&:hover": {
            backgroundColor: '#f5f6f9',
            borderColor: "#034A7F",
            "& svg": { color: "#034a7f" }
          },
        }}
      >
        {collapsed ? (
          <ChevronRight sx={{ color: "#000" }} />
        ) : (
          <ChevronLeft sx={{ color: "#000" }} />
        )}
      </IconButton>
    </Drawer>
  );
};

export default Sidebar;